import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=25b3066a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=25b3066a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b3066a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25b3066a')) {
      api.createRecord('25b3066a', component.options)
    } else {
      api.reload('25b3066a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=25b3066a&scoped=true&", function () {
      api.rerender('25b3066a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vb8QIjivVl6o/JS/comp/SearchFilterTokens.vue"
export default component.exports